<template>
    <div class="rating">
        <p><strong>Categoria:</strong> {{ category }} - {{ subcategory }}</p>

        <textarea
            :value="description"
            @input="$emit('update:description', $event.target.value)"
            rows="3"
            cols="30"
            placeholder="Inserisci una descrizione spontanea..."
        ></textarea>

        <label>Fascia oraria:</label>
        <select
            :value="timeRange"
            @change="$emit('update:timeRange', $event.target.value)"
            id="time-range"
        >
            <option value="">-- Seleziona una fascia --</option>
            <option value="00:00-04:00">00:00-04:00</option>
            <option value="04:00-08:00">04:00-08:00</option>
            <option value="08:00-12:00">08:00-12:00</option>
            <option value="12:00-16:00">12:00-16:00</option>
            <option value="16:00-20:00">16:00-20:00</option>
            <option value="20:00-24:00">20:00-24:00</option>
        </select>

        <div
            class="rating-group"
            v-for="(label, i) in rating_adj"
            :key="i"
        >
            <label>{{ label }}:</label>
            <div class="stars">
                <template v-for="value in 5" v-bind:key="value">
                    <input
                        type="radio"
                        :id="`${label}${id}${value}`"
                        :name="`${label}${id}`"
                        :value="value"
                        :checked="ratings[label] === value"
                        @change="$emit('update:rating', { id, label, value: Number(value) })"
                    />
                    <label :for="`${label}${id}${value}`">★</label>
                </template>
            </div>
        </div>

        <button class="btn btn-danger btn-sm" @click="$emit('delete')">Cancella Marker</button>
    </div>
</template>

<script>
export default {
    props: {
        id: Number,
        category: String,
        subcategory: String,
        rating_adj: Array,
        ratings: Object,
        timeRange: String,
        description: String,
    },
};
</script>

<style scoped>
#time-range {
    width:100%;
    padding:4px;
    margin-bottom:10px;
}
</style>
